import { Box, Grid, Typography } from "@material-ui/core";
import ProductCategory from "./productCategoryForm";

export default function ProductCategoryEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          eShop &gt; Edit Category
        </Typography>
      </Box>
      <Grid container xs={6}>
        <ProductCategory
          description="Edit Category"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
